import {
  COLAPSE_DASH, GET_TABS, SWITCH_TAB, SET_SELECTION_ELEMENTS, CHANGE_CHECKBOX, CHANGE_COLUMN_CHECKBOX
} from "../constans";
import {
  // tableSelect,
  resizeViewer,
} from "../../utils/builder/ITestLogic";
import { logError } from "../../utils/builder/IAmecLog";

export const ElementsAction = (elements) => async (dispatch) => {
  // try {
  //   await tableSelect(elements);
  // } catch (err) {
  //   logError("FrontEnd.src.store.actions.table.ElementsAction", err.toString());
  // }
};

export const colaplseDashboard = (element) => async (dispatch) => {
  await dispatch({
    type: COLAPSE_DASH,
    payload: element,
  });

  resizeViewer();
};

export const getTabs = (tabs) => ({
  type: GET_TABS,
  payload: tabs,
});

export const switchTab = (id) => ({
  type: SWITCH_TAB,
  payload: id,
});

export const setSelectionItems = (payload) => ({
  type: SET_SELECTION_ELEMENTS,
  payload: payload,
});

export const changeCheckbox = (payload) => ({
  type: CHANGE_CHECKBOX,
  payload: payload,
});

export const changeColumnCheckbox = (payload) => ({
  type: CHANGE_COLUMN_CHECKBOX,
  payload: payload,
});